<template>
  <v-dialog max-width="600px" v-model="visible">
    <v-btn flat color="green" slot="activator" class="mb-2">
      <span>Add Crew Member</span>
      <v-icon right>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Add a new crew member</h2>
      </v-card-title>

      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field label="First Name" v-model="firstName" :rules="requiredRules" outline />
          <v-text-field label="Last Name" v-model="lastName" :rules="requiredRules" outline />
          <v-text-field label="Email Address" v-model="email" :rules="emailRules" outline />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <span id="error" class="error--text pl-4 title">{{ error }}</span>
        <v-spacer />
        <v-btn color="blue" class="mr-4 mb-2" @click="createCrewMember">
          <span>Create</span>
          <v-icon right>add</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {CrewMembers} from '../fbConfig';

export default {
  name: 'AddCrewMember',
  data() {
    return {
      visible: false,
      firstName: '',
      lastName: '',
      email: '',
      error: '',
      requiredRules: [
        val => !!val || 'This field is required'
      ],
      emailRules: [
        val => !!val || 'This field is required',
        val => new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(val) || 'Invalid email'
      ]
    };
  },
  methods: {
    createCrewMember() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      const name = `${this.firstName.trim()} ${this.lastName.trim()}`;

      for (const member of this.$store.state.crewMembers) {
        if (member.name === name) {
          this.error = 'A user with that name already exists!';

          setTimeout(() => { this.error = ''; }, 5000);
          return;
        }
      }

      const crewMember = {
        name,
        email: this.email,
        inactive: false,
        games: 0
      };

      CrewMembers.add(crewMember).then(() => {
        this.visible = false;
        this.$refs.form.reset();
      });
    }
  }
};
</script>

<style scoped>

</style>
